import React, { type FormEvent } from 'react';
import { option } from "./option";

interface Props {
  title?: string;
  product?: string;
  pVersion?: string;
  sVersion?: string;
}

export default function FilterForm({title, product, pVersion, sVersion}:Props) {
  function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    const formData = new FormData(event.currentTarget);
    const formDataObject = Object.fromEntries(formData.entries() as Iterable<[string, string]>);
    const queryString = new URLSearchParams(formDataObject).toString();

    window.location.href = `/kb?${queryString}`;
  }

  return (
    <form onSubmit={handleSubmit} className='flex flex-col md:flex-row gap-6 justify-between items-center'>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        <input type="text" name="title" placeholder={!!title ? title : "Search by Keywords"} className='placeholder:text-gray-200 bg-white border-gray-100 focus:border-gray-300 focus:outline-none rounded-md'/>
        <select name="product" className="rounded-md border-gray-100 focus:border-gray-300" defaultValue={product ?? "*"}>
          {option.products.map((_p: any, index: number) => (
            <option key={index+_p.value} value={_p.value}>{_p.label}</option>
          ))}
        </select>
        <select name="product_version" className="rounded-md border-gray-100 focus:border-gray-300" defaultValue={pVersion ?? "*"}>
          {option.productVersions.map((_pv: any, index: number) => (
            <option key={index+_pv.value} value={_pv.value}>{_pv.label}</option>
          ))}
        </select>
        <select name="sharepoint_version" className="rounded-md border-gray-100 focus:border-gray-300" defaultValue={sVersion ?? "*"}>
          {option.sharepointVersions.map((_sv: any, index: number) => (
            <option key={index+_sv.value} value={_sv.value}>{_sv.label}</option>
          ))}
        </select>
      </div>
      <div className='w-full md:w-auto max-w-[290px]'>
        <button type="submit" className="w-full bg-primary rounded-lg py-2 px-8 lg:px-5 text-white font-semibold">search</button>
      </div>
    </form>
  );
}
